/**
 * 자동화 관련 상태 관리 store
 * @type {Object}
 */
const ams = {
  state: {
    /**
     * 자동화 모델링 결과 강제 로드 여부
     * @type {Boolean}
     */
    forceAmsModelingResultLoad: false,
    /**
     * 자동화 트리거(혹은 템플릿)수행 결과 강제 로드 여부
     * @type {Boolean}
     */
    forceAmsTriggerResultLoad: false,
  },
  mutations: {
    /**
     * 자동화 모델링 결과 강제 로드 여부를 설정한다.
     * @author jeee12
     * @param  {[type]} state   [description]
     * @param  {[type]} loading [description]
     */
    setForceAmsModelingResultLoad: (state, loading) => {
      state.forceAmsModelingResultLoad = loading;
    },
    /**
     * 자동화 트리거(혹은 템플릿)수행 결과 강제 로드 여부를 설정한다.
     * @author jeee12
     * @param  {[type]} state   [description]
     * @param  {[type]} loading [description]
     */
    setForceAmsTriggerResultLoad: (state, loading) => {
      state.forceAmsTriggerResultLoad = loading;
    },
  },
  actions: {
    /**
     * 자동화 모델링 결과 강제 로드 여부를 설정한다.
     * @author jeee12
     * @param  {[type]} commit  [description]
     * @param  {[type]} loading [description]
     */
    setForceAmsModelingResultLoad({ commit }, loading) {
      commit('setForceAmsModelingResultLoad', loading);
    },
    /**
     * 자동화 트리거(혹은 템플릿)수행 결과 강제 로드 여부를 설정한다.
     * @author jeee12
     * @param  {[type]} commit  [description]
     * @param  {[type]} loading [description]
     */
    setForceAmsTriggerResultLoad({ commit }, loading) {
      commit('setForceAmsTriggerResultLoad', loading);
    },
  },
};

export default ams;



// WEBPACK FOOTER //
// ./src/store/modules/ams.js